import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-1.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')